import React from 'react';
import { TypeAnimation } from 'react-type-animation';
import './Profile.css'

export default function Profile({ onClick }) {
    const handleClick = () => {
        onClick('4')
    }
  return (
    <div className="profile-container">
        <div className="row profile-parent">
                <div className="col-12 col-md-8">
                    <div className="profile-details">
                        <div className="profile-details-name">
                            <span className="primary-text">
                                Hello, I'M <span className="highlighted-text">Walid</span>
                            </span>
                        </div>

                        <div className="profile-details-role">
                            <span className="primary-text">
                                <h1>
                                    <TypeAnimation 
                                        sequence={[
                                            "Full Stack Developer 💻",
                                            1200,
                                            "Innovative Web Solutions 💡",
                                            1200,
                                        ]}
                                        wrapper="span"
                                        cursor={true}
                                        repeat={Infinity}
                                    />
                                </h1>
                                <span classname="profile-role-tagline">
                                    Transforming Ideas into High-Performing Web Applications that Empower Businesses and Enrich User Experience
                                </span>
                            </span>
                        </div>
                        <div className="profile-options">
                            <button className="btn primary-btn" onClick ={handleClick}>
                                Hire Me{" "}
                            </button>
                            <a href="resume.pdf" download="Walid Bouloukt.pdf">
                                <button className="btn highlighted-btn">Get Resume</button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-4">
                    <div className="profile-picture">
                        <div className="profile-picture-background"></div>
                    </div>
                </div>
        </div>
    </div>
  )
}
